import React from 'react';
import { Modal, Alert, Result } from 'antd';

import type { Readiness } from '../hooks';

type Props = {
  open: boolean;
  planName: string;
  readiness: Readiness;
  publishProblems?: string[];
  saving: boolean;
  onPublish: () => void;
  onClose: () => void;
};

/**
 * Publish pre-flight. Shows the client-side readiness check up front; the real N5
 * gate runs server-side on Publish and, if it 409s, its problem list replaces the
 * pre-check here. A clean publish flips the plan to `published` and the shell closes
 * this modal.
 */
const PublishPreflightModal: React.FC<Props> = ({
  open,
  planName,
  readiness,
  publishProblems,
  saving,
  onPublish,
  onClose,
}) => {
  const serverBlocked = !!publishProblems && publishProblems.length > 0;
  const problems = serverBlocked ? publishProblems! : readiness.problems;
  const blocked = serverBlocked || !readiness.ready;

  return (
    <Modal
      title={`Publish "${planName}"`}
      open={open}
      onCancel={onClose}
      okText={blocked ? 'Publish anyway' : 'Publish'}
      okButtonProps={{ loading: saving, danger: blocked }}
      onOk={onPublish}
    >
      {blocked ? (
        <Alert
          type={serverBlocked ? 'error' : 'warning'}
          showIcon
          message={
            serverBlocked
              ? 'The server blocked publish'
              : `${problems.length} issue${problems.length === 1 ? '' : 's'} found`
          }
          description={
            <ul style={{ margin: '8px 0 0 0', paddingLeft: 18 }}>
              {problems.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          }
        />
      ) : (
        <Result
          status="success"
          subTitle="No blockers found. Publishing makes this tree immutable and trainee-visible."
        />
      )}
    </Modal>
  );
};

export default PublishPreflightModal;
